import { Space, Spin } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import DotSeparator from 'components/new-ui/base/dot-separator/DotSeparator';
import { Declaration } from 'store/declarations/declaration';
import { InfoTitle } from 'views/declarations/common/DeclarationInformation.styles';
import MirroredDeclarationLink from './MirroredDeclarationLink';
import { LinksItem, LinksList, Wrapper } from './styles';

type Props = {
    declarations: Declaration[];
    isLoading: boolean;
    manifestId?: string;
    jobId?: string;
};

const MirroredDeclarationsLinksList = ({ declarations, isLoading, manifestId, jobId }: Props) => {
    if (isLoading) {
        return (
            <Space size={4}>
                <Spin size="small" />
                <span>Loading linked declarations...</span>
            </Space>
        );
    }

    if (declarations.length === 0) return null;

    return (
        <Wrapper data-testid="mirrored-declarations-links">
            <LinkOutlined style={{ color: 'var(--brand-6)' }} />
            <InfoTitle style={{ alignSelf: 'center', display: 'block' }}>Linked to: </InfoTitle>
            <LinksList>
                {declarations.map((declaration, index) => (
                    <LinksItem key={declaration.id}>
                        {index > 0 && <DotSeparator />}
                        <MirroredDeclarationLink declaration={declaration} manifestId={manifestId} jobId={jobId} />
                    </LinksItem>
                ))}
            </LinksList>
        </Wrapper>
    );
};

export default MirroredDeclarationsLinksList;
